
const __githubUiWorker = {url: url => url.href}
export default __githubUiWorker.url(new URL("./datadog-worker.ts?worker-entry", import.meta.url))
